module.exports = __webpack_public_path__ + "img/Huang_Huang-500x500.3f4c2568.jpg";